import { Lookup } from "../models/lookup.model";



export const lookupReducer = (state: Lookup, action: { type: string; value: Lookup; }) => {
    switch (action.type) {
        case 'set': return action.value;
        default: throw new Error('Unexpected action');
    }
};